import { PORTFOLIO_TIME_FORMAT, STRATEGY_CREATION_METHOD } from '@app/_helpers';
import { Utils } from '@app/_helpers/utilities';
import { GetAlgoResponse } from '@app/_shared';
import { PRODUCT_OPTIONS, PortfolioCreationType } from '@app/_shared/modules/portfolio-form/portfolio-form.enums';
import { PortfolioProductType } from '@app/_shared/modules/portfolio-form/portfolio.enums';
import { ExitDetails, executionDaysParams, portfolioDetails } from '@app/_shared/modules/portfolio-form/portfolio.interface';
import { StrategyModal } from '@app/_shared/modules/portfolio-form/portfolio.model';
import { ALLOWED_STRATEGY_DAYS } from '@app/_shared/modules/strategy-form/strategy.constants';
import { AlgoSymbolPosition } from '@app/_shared/providers/algowise-position-data/algo-symbol-position.model';
import { RiskOMeterRev } from '@app/_shared/shared.enums';
import { DashboardDefaultStrategyType } from '@app/_shared/shared.structs';
import * as moment from 'moment';
import { ExecutionDaysType, ExitExecutionDays, WebApiStrategyRunningType } from '../../../../../../../utProto//webApiStrategyEnums_pb';
import { StrategyStatus } from '../../../../../../../utProto/enums_pb';
import { MarketPlaceCardsType } from '../../../dashboard/components/marketplace-cards/marketplace-cards.consts';
import { MyStrategyType } from '../../../my-strategies/my-strategies.consts';
import { AlgoObj, BacktestStatus, BriefPortfolioResponse, BriefStrategyResponse, OriginalPortfolioDetail, PortfolioDynamicCardFields, PortfolioStatus, StrategyCardProductType, StrategyProductType, WinsLosses, strategyDetails } from './market-place.interface';


export class BriefStrategyModel {
    strategyID: string;
    algo_name: string;
    bookmarked: boolean;
    algo_description: string;
    client_id: string;
    created_at: number;
    deployments = 0;
    drawdown: number = 0;
    minimumCapital: number;
    minCash: number;
    minimumCapitalOnExpiry?: number;
    minCashOnExpiry?: number;
    monthlyFee: number;
    variableFee: number;
    feeSchedule: string;
    roi: number = 0;
    starred: boolean;
    stars: number;
    tags: string[];
    subscribed: boolean;
    totalSubscribers: number;
    deployed: boolean;
    algo: AlgoObj;
    minimumMultiplier: number;
    maximumMultiplier: number;
    positionObjects?: Map<string, Map<string, AlgoSymbolPosition>>;
    UniqueAlgoName?: string;
    paused: boolean;
    stopped: boolean;
    public: boolean;
    creationMethod = STRATEGY_CREATION_METHOD.PORTFOLIO;
    oldStatus: {
        UniquePortfolioId: string;
        status: number;
        StrategyDetailKey: any;
        runningType: any
    }[] = [];
    startTime: number;
    squareOffTime: number;
    runningPortfolioEndTime?: number;
    endTime: number;
    executeDays: number[];
    executionDaysParams: executionDaysParams;
    portfolioCreationType: number;
    productType: StrategyCardProductType[];
    numberOfStrategies?: number = 0;

    /**
     * Info section in each card
     * label: label to be shown
     * value: parameter to be useda as value
     * isColored: bool for text positive or negative as per value
     * colorparameter: parameter to be used for this decision
     */
    matContent: {
        label: string;
        value: string | Object;
        isColored: boolean;
        colorParameter?: any;
        currencyLogo?: boolean;
        positionObjParam?: string;
        field?: string;

    }[];

    constructor(response: BriefStrategyResponse) {
        Object.keys(response).forEach(key => this[key] = response[key]);
        this.created_at *= 1e3;
        this.strategyID = response._id;
        this.paused == !!this.paused;
        this.stopped == !!this.stopped;
    }


    get isExternalStrategy() {
        return (this.creationMethod === STRATEGY_CREATION_METHOD.CPP_TYPE) || (this.creationMethod === STRATEGY_CREATION_METHOD.REST_TYPE);
    }

    convertFromSingleStrategyResponse(response: GetAlgoResponse) {
        this.algo_name = response.algoName;
        this.created_at = response.createdAt * 1e3;
        this.algo_description = response.algoNotes;
        this.deployments = response.deployers?.length || 0;
        this.deployed = response.deployers?.length ? true : false;
        this.subscribed = response.subscribers?.length ? true : false;
    }

    // Will be used to preapre data as per card type, corresponding handling in HTML will render the card
    prepMatContent(type: MyStrategyType | MarketPlaceCardsType) {
        if (type === MyStrategyType.Deployed) {
            this.matContent = [
                {
                    label: 'PnL',
                    value: this.pnl,
                    isColored: true,
                colorParameter: this.pnl,
                    currencyLogo: true,
                    field: 'pnl'

                },
            ]
        } else if (type === MarketPlaceCardsType.Originals
            || type === MyStrategyType.Subscribed
            || type === MyStrategyType.Originals
            || type === MarketPlaceCardsType.Verified
            || ((type === MyStrategyType.Created || type === MyStrategyType.Saved) && this.isExternalStrategy)
        ) {
            this.matContent = [
                {
                    label: 'Start Time',
                    value: Utils.standardiseTime(this.startTime)?.format(PORTFOLIO_TIME_FORMAT),
                    isColored: false,
                    field: 'startTime'

                },
                {
                    label: 'End Time',
                    //If productype is CF, so endtime is 0 it converts to 12:00 AM , so giving it null
                    value:  Utils.standardiseTime(this.endTime)?.format(PORTFOLIO_TIME_FORMAT),
                    isColored: false,
                    field: 'endTime'
                },
                {
                    label: 'Execute On' ,
                    value: this.executeDaysOnCard() ,
                    isColored: false,
                    field: 'executeDays',
                },
            ]
        } else if (type == MyStrategyType.Shared){
            this.matContent = [
                {
                    label: 'Strategies',
                    value: this.numberOfStrategies,
                    isColored: false,
                    field: 'numberOfStrategies'
                },
                {
                    label: 'Start Time',
                    value: Utils.standardiseTime(this.startTime)?.format(PORTFOLIO_TIME_FORMAT),
                    isColored: false,
                    field: 'startTime'

                },
                {
                    label: 'End Time',
                    //If productype is CF, so endtime is 0 it converts to 12:00 AM , so giving it null
                    value: Utils.standardiseTime(this.endTime)?.format(PORTFOLIO_TIME_FORMAT),
                    isColored: false,
                    field: 'endTime'
                },
                {
                    label: 'Execute On',
                    value: this.executeDaysOnCard(),
                    isColored: false,
                    field: 'executeDays'
                },
            ]
        } else {
            this.matContent = [

                {
                    label: 'Start Time',
                    value: Utils.standardiseTime(this.startTime)?.format(PORTFOLIO_TIME_FORMAT),
                    isColored: false,
                    field: 'startTime'

                },
                {
                    label: 'End Time',
                    //If productype is CF, so endtime is 0 it converts to 12:00 AM , so giving it null
                    value: Utils.standardiseTime(this.endTime)?.format(PORTFOLIO_TIME_FORMAT),
                    isColored: false,
                    field: 'endTime'
                },
                {
                    label: 'Execute On',
                    value: this.executeDaysOnCard(),
                    isColored: false,
                    field: 'executeDays',
                },
            ]
            if (type === MyStrategyType.Created) {
                this.subscribed = true;
            }
        }
    }

    executeDaysOnCard() {
        if (this.executionDaysParams?.executionDaysType === ExecutionDaysType.EXECUTIONDAYSTYPE_WEEK_DAYS) {
            return this.executionDaysParams?.executeDays?.includes(ExitExecutionDays.EXITEXECUTIONDAYS_ALL) ? "All" : this.executionDaysParams.executeDays?.map(day => ALLOWED_STRATEGY_DAYS[day - 1]).join(',');
        } else {
            return Utils.executionDaysOnCard(this.executionDaysParams?.operatorType, this.executionDaysParams?.daysToExpiry);
        }
    }

    get mtm() {
        let mtm = 0;
        if (this.positionObjects) {
            this.positionObjects.forEach((el) => {
                el.forEach((key) => {
                    mtm += key.mtm;

                });
            })
        }
        return Utils.applyPrecision(mtm);
    }
    get bpl() {
        let bpl = 0;
        if (this.positionObjects) {
            this.positionObjects.forEach((el) => {
                el.forEach((key) => {
                    bpl += key.bookedPL;
                });
            })
        }
        return Utils.applyPrecision(bpl);
    }

    get pnl() {

        let pnl = 0;
        if (this.positionObjects) {
            this.positionObjects.forEach((el) => {
                el.forEach((key) => {
                    pnl += key.totalPL;

                });
            })
        }
        return Utils.applyPrecision(pnl);
    }
}


// TODO: Remove all unnecessary fields which are extended from BriefStrategyModel when final structure
// for Portfolios has been decided.
// NOTE: This was done temporarily to ensure backward compatibility so that current UI can work properly
export class BriefPortfolioModel extends BriefStrategyModel {
    portfolioID: string;
    uniquePortfolioID?: string;
    originalPortfolioId?: string;
    aiAssistantThreadID?: string; 
    aiAssistantMsgID?: string; 
    creator: string;
    createdAt: moment.Moment;
    updatedAt: moment.Moment;
    allbacktestStatus: any[];
    btStatus: number;
    portfolioName: string;
    isPublic: boolean;
    bookmarked: boolean;
    subscribed: boolean;
    paused: boolean = false;
    stopped: boolean = false;
    deployed: boolean = false;
    terminated: boolean = false;
    forceTerminated: boolean = false;
    status: number = 0;
    tags: string[];
    riskFactors: string[];
    favourableConditions: string[];
    overallSymbols: string[];
    strategies: StrategyModal[];
    soExtraParams? = {};
    marginRequired: number = 0;
    portfolioCreationType: number = 0;
    minimumMultiplier: number = 1;
    maximumMultiplier: number = 1;
    deployments: number = 0;
    runningType: number = 0;
    StrategyDetailKey: strategyDetails;
    multiplier: number = 1;
    deployed_on: number;
    margin_required: number = 0;
    disclaimer = '';
    displayName = '';
    verficationStatus: DashboardDefaultStrategyType;
    tokenID: number;
    terminatedAt: number;
    deployer: string;
    isQueued: boolean = false;
    pendingSqrOfStrategies: String[];
    cancelSquareOffStrategyKey: String[];
    originalPortfolioDetails?: OriginalPortfolioDetail[];
    version: number;
    productType: StrategyProductType[];
    riskOMeter: number;
    shareWithClients?: {[key: string]: number};
    sharedOn?: moment.Moment;
    isPortfolioPositionAvailable: boolean = false;
    overallExchanges: number[];
    autoDeployPortfolio: boolean;
    autoDeploymentDays: number[];
    portfolioExitParam: ExitDetails = null;
    wins?: number;
    losses?: number;
    _id?: string;
    ymlData?: string;
    portfolioDetails?: portfolioDetails;
    exitBeforeExpiry?: number;
    isReduceMultiplierAllowed?: boolean;
    broker?: string;

    /**
     * Keys from `dynamicCardContext` on the API response and/or the constructor `dynamicCardFields` argument.
     * Copied into strategy-card `buildCardContext` under the same names for dynamic layout bindings.
     */
    dynamicCardFields: PortfolioDynamicCardFields = {};

    /** Merged dynamic card keys are also set on the portfolio instance under the same names as in the source object. */
    [key: string]: any;

    constructor(
        response: BriefPortfolioResponse,
        portfolioStatus: PortfolioStatus = null,
        backtestStatus: BacktestStatus = null,
        winsLosses: WinsLosses = null,
        extraDynamicCardFields: PortfolioDynamicCardFields | null = null,
    ) {
        super(response as any);
        Object.keys(response).forEach(key => {
            this[key] = response[key];
        });
        if (winsLosses) {
            this.wins = winsLosses.wins;
            this.losses = winsLosses.losses;
        }
        if (portfolioStatus) {
            Object.keys(portfolioStatus).forEach(key => {
                if (key !== 'portfolioName') {
                    this[key] = portfolioStatus[key]; 
                }
            });
        }
        if (backtestStatus) {
            this.allbacktestStatus = [];            
            Object.keys(backtestStatus).forEach(key => {
                this.allbacktestStatus.push(backtestStatus[key]); 
            });
        }
        this.createdAt = moment(response?.createdAt?.$date);
        this.updatedAt = moment(response?.updatedAt?.$date);
        this.deployed = portfolioStatus?.status === StrategyStatus.STRATEGYSTATUS_RUNNING;
        this.paused = portfolioStatus?.status === StrategyStatus.STRATEGYSTATUS_PAUSED ? (this.deployed = true) : false;
        this.stopped = portfolioStatus?.status === StrategyStatus.STRATEGYSTATUS_STOP_FOR_TODAY;
        this.terminated = portfolioStatus?.status === StrategyStatus.STRATEGYSTATUS_TERMINATED;
        this.forceTerminated = portfolioStatus?.status === StrategyStatus.STRATEGYSTATUS_FORCE_TERMINATED;
        this.portfolioID = response._id;
        this.deployed_on = response?.deployed_on ? response.deployed_on * 1000 : null;
        this.terminatedAt = response?.terminatedAt ? response.terminatedAt * 1000 : null;
        this.margin_required = Utils.applyPrecision(response?.margin_required);
        this.isQueued = !!response.isQueued;
        this.productType = response?.productType;
        this.shareWithClients = response?.shareWithClients;
        this.sharedOn = response?.portfolioSharedOn ? moment(response.portfolioSharedOn * 1000) : null;

        this.mergeDynamicCardFields(response?.dynamicCardContext);
        this.mergeDynamicCardFields(extraDynamicCardFields);

        BriefStrategyCache.Instance.addPortfolio(this)
    }

    private mergeDynamicCardFields(block: PortfolioDynamicCardFields | null | undefined): void {
        if (!block || typeof block !== 'object') {
            return;
        }
        for (const key of Object.keys(block)) {
            if (key === 'dynamicCardFields') {
                continue;
            }
            const value = block[key];
            this.dynamicCardFields[key] = value;
            this[key] = value;
        }
    }

    get productTypes(): PortfolioProductType[] {
        if (!this.productType || !this.productType.length) {
            return [PortfolioProductType.INTRADAY];
        }
        const types = this.productType.map(strategy => strategy.productType).filter(type => type !== undefined);
        const res = Array.from(new Set(types));
        return res.length ? res : [PortfolioProductType.INTRADAY]
    }

    get isPortfolio() {
        return this.creationMethod === STRATEGY_CREATION_METHOD.PORTFOLIO;
    }
    get isPositionAvailable() {
        if (this.positionObjects?.size) {
            for (let el of this.positionObjects.values()) {
                for (let value of el.values()) {
                    if (value['openQuantity']) {
                        return true;
                    }
                }
            }
        }
        return false;

    }

    filterQueryInPortfolio (searchQuery: string) {
        return (this.portfolioName.toLowerCase().includes(searchQuery)
          || this.tags?.some((tags) => tags.toLowerCase().includes(searchQuery))
          || this.riskFactors?.some((riskFactors) => riskFactors.toLowerCase().includes(searchQuery))
          || (this.riskOMeter ? RiskOMeterRev[this.riskOMeter]?.toLowerCase().includes(searchQuery) : false)
          || PRODUCT_OPTIONS[this.productTypes[0]]?.toLowerCase().includes(searchQuery)
          || this.favourableConditions?.some((favourableConditions) => favourableConditions.toLowerCase().includes(searchQuery)))
    }

    strategyPositionAvailable(strategyId) {  
        if (this.positionObjects?.size && this.positionObjects.get(strategyId)) {
            const strategyPositions = this.positionObjects.get(strategyId);
            for (let value of strategyPositions.values()) {
                if (value['openQuantity']) {
                    return true;
                }
            }
        }
    }

    updateOriginalPortfolioDetails(originalPortfolioDetails: OriginalPortfolioDetail[]) {
        this.originalPortfolioDetails = originalPortfolioDetails;
    }

    updatePortfolioState(status) {
        this.deployed = status === StrategyStatus.STRATEGYSTATUS_RUNNING;
        this.paused = status === StrategyStatus.STRATEGYSTATUS_PAUSED ? (this.deployed = true) : false;
        this.stopped = status === StrategyStatus.STRATEGYSTATUS_STOP_FOR_TODAY;
        this.terminated = status === StrategyStatus.STRATEGYSTATUS_TERMINATED;
        this.forceTerminated = status === StrategyStatus.STRATEGYSTATUS_FORCE_TERMINATED;
    }

    get liveDeployments() {
        let totalLiveDeployments = 0;
        if (this.oldStatus?.length) {
            this.oldStatus.forEach((status) => {
                if (status.runningType === WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE) {
                    totalLiveDeployments++
                }
            })

        }
        return totalLiveDeployments;

    }

    get totalDeployments() {
        let totalDeployed = 0;
        if (this.oldStatus?.length) {
            totalDeployed = this.oldStatus.reduce((total, currStatus) => {
                if (currStatus.status === StrategyStatus.STRATEGYSTATUS_TERMINATED) {
                    return total + 1;
                }
                return total;
            }, 0); // initializing the total terminated strategy with zero.This value is
            // passed as parameter total in callback function in above reduce function
        }
        return totalDeployed;
    }

    get isCopyOfOriginals() {
        return (this.portfolioCreationType === PortfolioCreationType.Copy && this.originalPortfolioDetails && this.originalPortfolioDetails.length &&
            this.originalPortfolioDetails[0]?.isPublic);
    }

}

export class BriefStrategyCache {
    private portfolioMap = new Map<string, BriefPortfolioModel>();
    private portfolioUniqueIDMap = new Map<string, BriefPortfolioModel>();

    private static _instance: BriefStrategyCache;

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    addPortfolio(portfolio: BriefPortfolioModel) {
        this.portfolioMap.set(portfolio.portfolioID, portfolio);
        if (portfolio.uniquePortfolioID) {
            this.portfolioUniqueIDMap.set(portfolio.uniquePortfolioID, portfolio);
        }

        // if (portfolio.oldStatus?.length) {
        //     portfolio.oldStatus.forEach((status) => {
        //         this.portfolioUniqueIDMap.set(status.UniquePortfolioId, portfolio);
        //     })
        // }
    }

    updateUniqueIdByPortfolioID(portfolioID: string, uniquePortfolioID: string) {
        if (this.portfolioMap.has(portfolioID)) {
            this.portfolioUniqueIDMap.set(uniquePortfolioID, this.portfolioMap.get(portfolioID));
        } else {
            console.log('Could not move to unique', this.portfolioMap);
        }
    }

    getPortfolioByID(portfolioId: string) {
        return this.portfolioMap.get(portfolioId);
    }

    getPortfolioByUniqueID(uniquePortfolioId: string) {
        return this.portfolioUniqueIDMap.get(uniquePortfolioId);
    }

    updatePortfolioByPortfolioId(portfolioId: string, portfolio: BriefPortfolioModel) {
        if (this.portfolioMap.has(portfolioId)) {
            this.portfolioMap.set(portfolioId, portfolio);
        }
    }
}
